import React from "react";
import styles from "./WHYCHOOSEUS.module.css";
import { FiGlobe, FiLayers, FiShield, FiUsers } from "react-icons/fi";

const features = [
  {
    id: 1,
    icon: <FiGlobe />,
    title: "Expertise Across Industries:",
    description:
      "With experience in diverse sectors like aerospace, finance, and renewable energy, we understand the unique challenges and needs of your industry."
  },
  {
    id: 2,
    icon: <FiLayers />,
    title: "Comprehensive Services:",
    description:
      "From outsourcing and talent management to digital experience, we offer a full suite of IT services tailored to your business goals."
  },
  {
    id: 3,
    icon: <FiShield />,
    title: "Commitment to Quality:",
    description:
      "Our team is dedicated to delivering high-quality solutions that meet your specific needs and drive your business forward."
  },
  {
    id: 4,
    icon: <FiUsers />,
    title: "Customer-Centric Approach:",
    description:
      "Transparent communication, dedicated sprint alignment, and regular executive touchpoints ensure our delivery maps directly to your KPIs."
  }
];

const WHYCHOOSEUS = () => {
  return (
    <section className={styles.sectionWrapper}>
      <div className={styles.container}>
        {/* Header Section */}
        <div className={styles.header}>
          <span className={styles.pillBadge}>WHY PROVAANTECH</span>
          <p className={styles.categorySubhead}>WHY CHOOSE PROVAANTECH</p>
          <h2 className={styles.mainHeading}>
            Engineering Precision. Enterprise Outcomes.
          </h2>
          <p className={styles.subText}>
            Our team is dedicated to delivering high-quality solutions that meet your specific needs and drive your business forward.
          </p>
        </div>

        {/* Glow Line Connector */}
        <div className={styles.glowLineWrapper}>
          <div className={styles.glowLine}></div>
        </div>

        {/* 4 Cards Grid */}
        <div className={styles.cardsGrid}>
          {features.map((feature) => (
            <div key={feature.id} className={styles.card}>
              <div className={styles.iconWrapper}>
                <span className={styles.icon}>{feature.icon}</span>
              </div>
              <h3 className={styles.cardTitle}>{feature.title}</h3>
              <p className={styles.cardDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WHYCHOOSEUS;

